var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#71c2ea;}.cls-3{fill:#00a0df;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.24,323.81l-57,50.24V226l57,50.24A31.72,31.72,0,0,1,272.24,323.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600,85.18V515.87a20,20,0,0,1-20.05,20H235.32a20,20,0,0,1-20-20V414.1l76.89-67.82a61.67,61.67,0,0,0,0-92.56L215.27,185.9V85.18a20,20,0,0,1,20-20H579.9A20,20,0,0,1,600,85.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.69,599.1,600,536.63V65.18L375.83,1.68A34,34,0,0,0,332.54,34.3V566.44A34,34,0,0,0,375.69,599.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 401.44,
    cy: 300.53,
    rx: 40.71,
    ry: 40.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.24,323.81l-57,50.24L165,418.39a31.28,31.28,0,0,1-20.91,8c-16.43,0-32.05-12.83-32.05-31.84V352H51.15a51.08,51.08,0,1,1,0-102.15H112V205.41c0-19,15.62-31.84,32.05-31.84a31.28,31.28,0,0,1,20.91,8L215.27,226l57,50.24A31.72,31.72,0,0,1,272.24,323.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLogin);
export default __webpack_public_path__ + "static/media/provider_login.1715ad1d9540e5354e73eb63302b5847.svg";
export { ForwardRef as ReactComponent };